import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'
import inputValueWidth from '../helpers/input_value_width'

// Connects to data-controller="field-dynamic-suffix"
export default class extends Controller {
  static targets = ['suffix', 'input']

  DEFAULT_GAP = 12

  connect () {
    if (!this.hasInputTarget) return
    if (!this.hasSuffixTarget) return

    // The input may be hidden on connect (collapsed section, hidden dialog, …),
    // where it has no layout box to measure. useIntersection lets us (re)compute
    // the suffix position as soon as the field actually becomes visible.
    useIntersection(this)

    this.inputListener = this.repositionSuffix.bind(this)
    this.element.addEventListener('input', this.inputListener)
    document.addEventListener('turbo:morph', this.inputListener)

    this.repositionSuffix()
  }

  disconnect () {
    this.element.removeEventListener('input', this.inputListener)
    document.removeEventListener('turbo:morph', this.inputListener)
  }

  appear () {
    this.repositionSuffix()
  }

  repositionSuffix () {
    const valueWidth = inputValueWidth(this.inputTarget)
    // For number inputs, if the value is invalid, input.value is an empty string, so the width is 0.
    // In this case, we don't want to reposition the suffix.
    if (valueWidth === 0) return

    const width = valueWidth + this.DEFAULT_GAP
    const inputWidth = this.inputTarget.getBoundingClientRect().width - this.DEFAULT_GAP * 2
    // When the input is hidden its box is 0 and the offset would be negative,
    // pushing the suffix outside the input. Leave it at its default position
    // until `appear` fires with the input visible.
    if (inputWidth <= 0) return

    const finalWidth = Math.min(width, inputWidth)
    this.suffixTarget.style.left = `${finalWidth}px`
  }
}
